module.exports = __webpack_public_path__ + "img/email_icon.2cd5c22a.svg";